import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'job',
        render: item => {
          if (item && item.type) {
            let jobUrl = `/jobView/${item.id}/${item.type.replace('/', '-')}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Job Name',
        width: 200,
        dataIndex: 'name'
      },
      {
        title: 'Company',
        width: 200,
        dataIndex: 'company_name',
        sorter: (a, b) => a.company_name.localeCompare(b.company_name)
      },
      {
        title: 'Monthly Contract Total',
        dataIndex: 'monthly_contract_total_formatteed'
      },
      {
        title: 'Contract Expiration Date',
        dataIndex: 'contract_expiration_date',
        sorter: (a, b) => {
          if (moment(a.contract_expiration_date).isBefore(moment(b.contract_expiration_date))) {
            return -1
          }
          return 1
        }
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Create Date',
        dataIndex: 'created_date',
        sorter: (a, b) => {
          if (moment(a.created_date).isBefore(moment(b.created_date))) {
            return -1
          }
          return 1
        }
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    let data = fullReport.map((item, index) => {
      item = { ...item } // This prevents rerendering mutation issues
      item.contract_expiration_date = moment(new Date(item.contract_expiration_date)).format(
        'YYYY-MM-DD'
      )
      item.created_date = moment(new Date(item.created_date)).format('YYYY-M-D')
      item.monthly_contract_total_formatteed = numeral(item.monthly_contract_total).format(
        '$0,0.00'
      )
      item.key = `${item.key}_${item.contract_expiration_date}`
      item.job = {
        id: item.id,
        type: item.type
      }
      return item
    })

    return data
  }

  getMonthlyContractTotal = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.monthly_contract_total
    })
    return sum
  }

  tableComponents = (key = 'tableKey') => ({ className, style, children }) => (
    <table className={className} style={style} key={key}>
      {children}
      <tfoot>
        <tr>
          <td className="padding8">Totals</td>
          <td />
          <td />
          <td className="padding8">{numeral(this.getMonthlyContractTotal()).format('$0,0.00')}</td>
          <td />
          <td />
          <td />
        </tr>
      </tfoot>
    </table>
  )

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <Table
              rowKey="key"
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              components={{ table: this.tableComponents() }}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/financial/maintenance-financials-report/ListItems.js